import React, { useRef, useCallback } from 'react';

import PropTypes from 'prop-types';

import { Form, DateTime } from '~/components/Form';
import { t, number } from '~/helpers';

import * as S from './styles';

function Header({ data, handleSubmit }) {
  const formRef = useRef(null);

  const handleAutoSubmit = useCallback(
    (fieldName) => (value) => {
      // Atualiza o campo alterado
      formRef.current.setFieldValue(fieldName, value);

      // Pega todos os dados e envia para handleSubmit manualmente
      const newData = formRef.current.getData();

      handleSubmit(newData);
    },
    [data]
  );

  return (
    <S.Wrapper>
      <S.WrapperTable>
        <table>
          <thead>
            <tr>
              <th>{t('s.indicadoroperacao.minimo')}</th>
              <th>{t('s.indicadoroperacao.meta')}</th>
              <th>{t('s.indicadoroperacao.maximo')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{number(82.5, 1)}</td>
              <td className="meta">{number(88, 1)}</td>
              <td>{number(93.5, 1)}</td>
            </tr>
          </tbody>
        </table>
      </S.WrapperTable>

      <Form ref={formRef} initialData={data}>
        <S.WrapperForm>
          <DateTime
            name="iniciomes"
            label={t('s.indicadoroperacao.iniciomes')}
            serialize={(value) => value.format('DD/MM/YYYY HH:mm:ss')}
            getValue={() =>
              setTimeout((value) => handleAutoSubmit('iniciomes')(value), 100)
            }
          />
          <DateTime
            name="inicioano"
            label={t('s.indicadoroperacao.inicioano')}
            serialize={(value) => value.format('DD/MM/YYYY HH:mm:ss')}
            getValue={() =>
              setTimeout((value) => handleAutoSubmit('inicioano')(value), 100)
            }
          />
        </S.WrapperForm>
      </Form>
    </S.Wrapper>
  );
}

Header.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default Header;
